import { BaseQuantity } from "../../interface/functionalityInterface";
// Derived base quantity
// coherent SI unit is kgm2s-2

export const Power: BaseQuantity = {
  id: "001power",
  name: "power",
  type: "numeric",
  value: "",
  symbol: "P",
  baseUnit: "W",
  selectedUnit: "W",
  units: [
    { name: "W", fromConst: 1, toConst: 1 },
    { name: "kW", fromConst: 1000, toConst: 1 / 1000 },
    { name: "J/s", fromConst: 1, toConst: 1 },
  ],
};
